import { useEffect } from "react";
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import { translate } from "../../../../../../components/translate/translate.jsx";

const StatusContent = ({data, dataTable, elementId, elementLabel, title, translateLabels = false}) => {
    const status = data?.[dataTable];

    useEffect(() => {
        const formattedStatus = status?.map(element => ({
            ...element,
            [elementLabel]: translateLabels ? translate(element[elementLabel]) : element[elementLabel]
        }));

        GraphicUtils.horizontalStackedBarChart(formattedStatus, elementId, elementLabel);
    }, [status, elementId, elementLabel, translateLabels]);

    return (
        <>
            <div className="chart-report">
                <span className="chart-title">{title}</span>
                <div className="mt-1" id={elementId}></div>
            </div>

            <div className="chart-divisor"/>
        </>
    );
};

export default StatusContent;